import { BASIC_NODE_CONFIG, BASIC_NODE_CONFIG_SIZE } from 'src/utils/basic'
import type { JavaPluginActionNodeType } from '../types'

export function generateJavaPluginActionNodeConfig(id: string): JavaPluginActionNodeType {
  return {
    ...BASIC_NODE_CONFIG,
    id,
    type: 'JavaPluginAction',
    data: {
      ...BASIC_NODE_CONFIG_SIZE,
      nodeName: '自定义操作',
      nodeType: 'JavaPluginAction',
      nodeData: {},
      nodeStyle: {},
      nodeId: '',
      hasErr: false,
      errInfo: [],
    },
    position: {
      x: 0,
      y: 0,
    },
  }
}
